<template>
  <div v-if="deliverable" class="deliverable-list-tags">
    <span class="text-uppercase field-label">Tags</span>
    <perfect-scrollbar ref="deliverable__tags__scroll">
    <div class="info-bubbles cursor-pointer exclude-outside-click" v-if="deliverable.tags" @click="showAddTag">
      <span
        v-show="!addTagFlag"
        v-for="(tag, index) in deliverable.tags"
        :key="index"
        class="exclude-outside-click badge badge-gray deliverable-tags"
      >{{ tag.name }}</span>
      <span v-show="!addTagFlag" v-if="deliverable.tags.length == 0" class="exclude-outside-click badge badge-gray deliverable-tags">No Tags</span>
      <plus-button v-show="!addTagFlag" class="tagged-tags"/>
    </div>
    </perfect-scrollbar>
    <multiselect
      ref="deliverableListTags"
      v-click-outside="outside"
      v-show="addTagFlag"
      v-model="deliverable.tags"
      v-if="deliverable.tags"
      :close-on-select="false"
      :options="tags"
      :show-labels="false"
      :multiple="true"
      :taggable="true"
      label="name"
      track-by="id"
      :id="deliverable.id"
      @tag="createTags"
      @input="updateFieldValue(deliverable)"
      @search-change="onTagSearch"
      @open="onTagSearch(false)"
      @close="addTagFlag=false"
    >
      <template slot="noOptions" slot-scope="props">
        Start typing to find tags.
      </template>

      <template slot="noResult" slot-scope="props">
        &nbsp;
      </template>

    </multiselect>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: ["deliverable"],
  data() {
    return {
      addTagFlag: false,
      tags: [],
      isTagsLoading: false
    };
  },
  computed: {
    ...mapGetters(['initialTags', 'userAbilities'])
  },
  methods: {
    ...mapActions(["updateFieldValue"]),
    showAddTag() {
      if(!this.userAbilities.editMediaCall || this.deliverable.permissions.viewOnly) return;
      this.addTagFlag = true
      this.$nextTick(() => {
        this.$refs.deliverableListTags.$el.focus()
      })
    },
    onTagSearch(input) {
      if(!input && (typeof this.initialTags != 'undefined' && this.initialTags.length > 0)) {
        this.tags = this.initialTags;
        return;
      }
      this.isTagsLoading = true
      input = input == false ? '' : input
      new Promise((resolve, reject) => {
        axios
          .get(process.env.MIX_API_BASE_URL + "tags?q=" + encodeURI(input))
          .then(resp => {
            this.isTagsLoading = false
            this.tags = []
            let x = 0;
            for (x = 0; x < resp.data.length; x++) {
              this.tags.push(resp.data[x]);
            }
            this.$store.commit('setInitialData', {tags: this.tags})
            resolve(this.tags);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    createTags(newTag, deliverableId) {
      this.$store.dispatch("createTag", { newTag, deliverableId });
    },
    outside() {
      this.$set(this, "addTagFlag", false);
    }
  }
};
</script>

<style>
</style>